export default __webpack_public_path__ + "fonts/arrow-down-blue.svg";